
import { mapState } from 'vuex'
import { mdiFilePdfBox } from '@mdi/js'
import DescriptionAndDefects from '@/components/catalog/product/details/DescriptionAndDefects'
import AttributeGroupTable from '@/components/catalog/product/details/AttributeGroupTable'
import Damages from '@/components/catalog/product/images/Damages'
import utils from '@/components/tools/utils'
import MoreInformationTable from '@/components/catalog/product/details/MoreInformationTable.vue'

export default {
  name: 'MotorhomeDetailsCards',
  components: { MoreInformationTable, Damages, AttributeGroupTable, DescriptionAndDefects },
  data: () => {
    return {
      tabProfile: 0,
      tabEquipment: 0,
      tabTitleClass: 'text-h6',
      mdiFilePdfBox,
      hymerHackEntities: [5343, 5399, 5428, 5972, 5974, 5976, 6100, 6402, 6475],
      hasOnlyOne: [6100, 6402]
    }
  },
  computed: {
    ...mapState('customer', {
      merchantAcceptedByCm24 (state) {
        if (state.merchant.acceptedByCm24) {
          return state.merchant.acceptedByCm24 === true
        } else {
          return false
        }
      }

    }),
    ...mapState('upload', ['attributes']),

    hymerHack () {
      return this.hymerHackEntities.includes(this.entityId) && this.merchantAcceptedByCm24
    },
    hymerDekraFiles () {
      if (this.hymerHack) {
        if (this.hasOnlyOne.includes(this.entityId)) {
          return [
            `https://img.caravanmarkt24.de/catalog/product/${this.entityId}/dekra.pdf`]
        } else {
          return [
            `https://img.caravanmarkt24.de/catalog/product/${this.entityId}/dekra.pdf`,
            `https://img.caravanmarkt24.de/catalog/product/${this.entityId}/dekra-2.pdf`]
        }
      } else {
        return this.documents
      }
    },
    ...mapState('product', {
      entityId: state => state.data?.entityId,
      product: state => state.data,
      translatedDescription: state => state.translatedDescription,
      translatedDefectsDescription: state => state.translatedDefectsDescription,
      damagesExists: state => state.data?.damages?.filter(damage => damage.image !== null)?.length > 0,
      defectsExists: (state) => {
        if (state.data?.attributes) {
          const found = Object.values(state.data?.attributes)?.find(attribute => attribute.attributeCode === 'defects_exists')
          if (found) {
            return found?.optionLabel?.toLowerCase() === 'ja'
          } else {
            return false
          }
        } else {
          return false
        }
      }
    }),
    documents () {
      if (this.product?.attributes) {
        return Object.values(this.product?.attributes)?.filter(attribute => attribute.attributeCode === 'document_1' || attribute.attributeCode === 'document_2'
        )?.map(attr => this.$config.imagesBaseUrl + '/' + attr.value)
          .sort((a, b) => a.localeCompare(b))
      } else {
        return []
      }
    },
    productAttributes () {
      return Object.values(this.product.attributes)
    },
    isMoreInformationShown () {
      const moreInformationStatus = this.productAttributes.find(
        attribute => attribute.attributeCode === 'more_information_status'
      )

      return moreInformationStatus?.value === 'submitted'
    },
    moreInformationSections () {
      const sections = [
        {
          titleKey: 'product.repaired_damage_details',
          attributeGroup: 'product_more_information_damage'
        },
        {
          titleKey: 'product.damage_details',
          attributeGroup: 'product_more_information_damage_not_repaired'
        },
        {
          titleKey: 'product.repaired_water_damage_details',
          attributeGroup: 'product_more_information_water_damage'
        },
        {
          titleKey: 'product.water_damage_details',
          attributeGroup: 'product_more_information_water_damage_not_repaired'
        },
        {
          titleKey: 'product.repaired_hail_damage_details',
          attributeGroup: 'product_more_information_hail_damage'
        },
        {
          titleKey: 'product.hail_damage_details',
          attributeGroup: 'product_more_information_hail_damage_not_repaired'
        }
      ]
      const moreInformationAttributes = this.productAttributes.filter(
        attribute => attribute.attributeSetName === 'product_more_information'
      )
      const groupedMoreInformationAttributes = this.groupBy(
        moreInformationAttributes,
        attribute => attribute.attributeGroupName
      )

      return sections
        .filter(
          section =>
            section.attributeGroup in groupedMoreInformationAttributes
        )
        .map(section => ({
          title: this.$t(section.titleKey),
          attributes: groupedMoreInformationAttributes[section.attributeGroup]
        }))
    }
  },
  methods: {
    groupBy (items, keySelector) {
      const groups = {}

      for (const item of items) {
        const key = keySelector(item)

        if (!(key in groups)) {
          groups[key] = []
        }

        groups[key].push(item)
      }

      return groups
    },
    formatAttributeValue ({ backendType, attributeCode, value }) {
      if (backendType === 'int') {
        return this.attributes[attributeCode].options.find(
          option => option.optionId === value
        ).label
      }

      if (backendType === 'decimal') {
        return utils.formatCurrency(value)
      }

      return value
    }
  }
}
